import React, { useEffect } from 'react'
import SubscriptionCheckout from "../Account/SubscriptionCheckout";
import {Elements} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';
import { createBillingPortalSessionApi, updateUserApi } from 'Constants';
import { useContext, useState } from 'react';
import { Context } from '../../Context/Context';
import { startSubsSession } from 'Constants';
import SubscriptionPlans from './SubscriptionPlans';
import { useNavigate } from 'react-router-dom';
import Header from 'Components/Header/Header';

function Subscription() {
    const {userDetails, makeApiCallFunc, setSelectedMenuItem} = useContext(Context);

    const [showModal, setShowModal] = useState(false);
    const [showCheckoutModal, setShowCheckoutModal] = useState(false);
    const [clientSecret, setClientSecret] = useState(null);
    const navigate = useNavigate();
    const [clientSubsId, setClientSubsId] = useState(null);
    const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);
    useEffect(() => {
      setSelectedMenuItem(null)
      if(userDetails?.verified === false)
      {
        navigate("/attorney/profile")
      }
    },[])
    useEffect(() => {
      if(userDetails?.isUserAssistant)
      {
        navigate("/attorney/casesFeed/availableCases")
      }
    }, [userDetails])
    const appearance = {
        theme: 'stripe',
      };
      const options = {
        clientSecret,
        appearance,
      };
      const createBillingPortalSession = async () => {
        makeApiCallFunc(createBillingPortalSessionApi,
            {},
            ({data}) => {
                window.location.href = data.url
            },
            (error) => console.log(error)
        )
    }
  return (
    
    <> 
    <Header /> 
    
      
    <div className='col-span-6 w-full font-plexsans px-4 py-6 lg:px-10 lg:py-9' style={{background:'#f7f4ed'}}>
      <h2 style={{margin:'0 0 22px', font:"400 21px/1.3 'Spectral',serif", color:'#14213d'}}>Membership plans</h2>
      <SubscriptionPlans
      onSubmit={userDetails?.isActiveSubscription ? createBillingPortalSession : null}
      />
    </div>
    
   
    
    </>
    
  )
}

export default Subscription